import { PERSONALIZATION_API_HOST, PERSONALIZATION_API_KEY } from './constants';

const subscribeUser = async (
  email: string,
  country: string,
  formName: string[],
  reCaptchaToken: string | undefined,
  pagePath: string,
  bypassReCaptcha?: boolean,
  signupConsent?: boolean,
  signupSource?: string,
  signupMedium?: string,
  signupCampaign?: string,
  pianoUid?: string,
) => {
  const body = {
    bypassReCaptcha,
    country,
    email,
    formName,
    pagePath,
    reCaptchaToken,
    signupConsent,
    signupSource,
    signupMedium,
    signupCampaign,
    pianoUid,
  };

  const response = await fetch(`${PERSONALIZATION_API_HOST}/subscribeUser`, {
    body: JSON.stringify(body),
    headers: {
      'x-api-key': PERSONALIZATION_API_KEY,
    },
    method: 'POST',
  });

  if (!response.ok) throw new Error('API error');

  return true;
};

export default subscribeUser;
